/*
 * SCSS → Tailwind token mapping (NewQuestionBtnTool.scss deleted):
 *
 * .nqbt-container:
 *   display:flex / justify-content:center / padding:20px → flex justify-center p-[20px]
 *   border: 1px dashed --border-card (#141E1F1A)         → border border-dashed border-shade-10
 *   border-radius: 8px                                   → rounded-large
 *
 * Note: p-[20px] — no exact DS token at 20px (sp-2=16px, sp-3=24px); arbitrary used intentionally.
 */
import { memo } from 'react'
import { Button, PlusIcon } from '@quickmd-llc/design-system'
import { INTAKE_FORMS_CREATE_QUESTION_NEW_QUESTION_BTN_ID } from '../../../../../utils/constants'

type Props = {
  onNewQuestionPress: (questionListLength: number) => void
  questionListLength: number
}

const NewQuestionBtnTool = memo(({ onNewQuestionPress, questionListLength }: Props) => {
  const onNewPress = () => {
    onNewQuestionPress(questionListLength)
  }

  return (
    <div className='flex justify-center rounded-large border border-dashed border-shade-10 p-[20px]'>
      <Button id={INTAKE_FORMS_CREATE_QUESTION_NEW_QUESTION_BTN_ID} priority='tertiary' size='s' onClick={onNewPress}>
        <PlusIcon iconSize='s' />
        Add question
      </Button>
    </div>
  )
})

export { NewQuestionBtnTool }
